import { ArrowUpRight, Gift, Share2, Users } from "lucide-react";
import { Reveal } from "./primitives";
import { APP_LINKS } from "../../lib/site";

const STEPS = [
  {
    icon: Share2,
    title: "Refer",
  },
  {
    icon: Users,
    title: "They go solar",
  },
  {
    icon: Gift,
    title: "You earn",
  },
];

export const ReferEarn = () => (
  <section className="relative overflow-hidden bg-navy py-24 text-white sm:py-32 lg:py-40" data-testid="refer-earn-section">
    <div className="pointer-events-none absolute -left-24 top-10 h-96 w-96 rounded-full bg-teal/20 blur-[120px]" />
    <div className="pointer-events-none absolute -right-24 bottom-0 h-96 w-96 rounded-full bg-amber/20 blur-[120px]" />
    <div
      className="pointer-events-none absolute inset-0 opacity-[0.12]"
      style={{
        backgroundImage: "linear-gradient(rgba(255,255,255,0.12) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.12) 1px, transparent 1px)",
        backgroundSize: "44px 44px",
      }}
      aria-hidden
    />

    <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="mx-auto max-w-4xl text-center">
          <Reveal>
            <p className="eyebrow mb-6 text-amber-400">Refer and Earn</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="display-serif text-4xl leading-[1.02] tracking-[-0.03em] sm:text-5xl lg:text-[4rem]">
              Share solar. Earn rewards.
            </h2>
          </Reveal>
      </div>

      <div className="mx-auto mt-14 grid max-w-5xl gap-5 md:grid-cols-3">
        {STEPS.map((step, index) => (
          <Reveal key={step.title} delay={0.12 + index * 0.08}>
            <article className="group h-full rounded-[1.5rem] border border-white/10 bg-white/[0.045] p-7 text-center backdrop-blur-md transition-[transform,border-color,background-color] duration-300 hover:-translate-y-1 hover:border-amber/35 hover:bg-white/[0.07]">
              <div className="mx-auto grid h-16 w-16 place-items-center rounded-2xl bg-white/8 text-amber-400 ring-1 ring-white/10 transition-transform duration-300 group-hover:scale-105">
                <step.icon size={30} strokeWidth={1.8} />
              </div>
              <div className="mt-7 flex items-center justify-center gap-3">
                <span className="display-serif text-2xl text-amber">0{index + 1}</span>
                <h3 className="text-2xl font-semibold tracking-tight">{step.title}</h3>
              </div>
              {index < STEPS.length - 1 && (
                <span className="mx-auto mt-6 hidden h-1 w-14 rounded-full bg-amber/60 md:block" />
              )}
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.18}>
        <div className="mt-12 text-center">
          <a
            href={APP_LINKS.customer.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-amber px-7 py-3.5 text-sm font-semibold text-white shadow-lg shadow-amber/25 transition hover:-translate-y-0.5 hover:bg-amber-600"
          >
            Download customer app <ArrowUpRight size={16} />
          </a>
          <p className="mt-4 text-xs text-white/38">Rewards subject to eligibility.</p>
        </div>
      </Reveal>
    </div>
  </section>
);
